import { Flex, Spinner } from '@arkestro/arkestro-design-system';

import styles from './LineItemsLoading.module.scss';

export const LineItemsLoading = () => (
  <div className={styles.noResultsContainer} data-testid='line-items-loading'>
    <Flex justify='center'>
      {/* Have to do inline styles here, when there are too many dom elements on tab, we lose
      targeting from theme provider for animation class. */}
      <Spinner
        className={styles.spinner} data-testid='line-items-loading-spinner' size='large' style={
          { animation: 'loadingCircle 1s infinite linear' }
        }
      />
    </Flex>
  </div>
);
